import React, { Component } from "react";
import AngleViewer from "./AngleViewer";
import Controls from "./Controls";

class Cut extends Component {
  state = {
    measurement: `3' 3/16"`,
    editing: false,
    focus: "left",
    left: {
      angle: 135,
      cut: "right",
      corner: "inside"
    },
    right: {
      angle: 135,
      cut: "left",
      corner: "inside"
    }
  };

  onChange = (side, key, val) => {
    if (key === "measurement") {
      return this.setState({ measurement: val });
    }
    let state = {
      ...this.state,
      [side]: { ...this.state[side], [key]: val }
    };

    this.setState(state);
  };

  onFocus = focus => {
    this.setState({ focus, editing: true });
  };

  onToggleEdit = () => {
    this.setState({
      editing: !this.state.editing
    });
  };

  render() {
    return (
      <div className="columns">
        <div className="column is-one-fifth">
          <h3 className="title">
            Cut #{this.props.index + 1} — {this.state.measurement}
          </h3>
          <div className="field is-grouped">
            <p className="control">
              <button
                className="button is-danger"
                onClick={this.props.onRemove}
              >
                <span className="icon is-small">
                  <i className="far fa-trash-alt" />
                </span>
                <span>Remove Cut</span>
              </button>{" "}
              <div className="dropdown is-hoverable">
                <div className="dropdown-trigger">
                  <button
                    className="button"
                    aria-haspopup="true"
                    aria-controls="dropdown-menu"
                    onClick={this.onToggleEdit}
                  >
                    <span>Edit Cut</span>
                    <span className="icon is-small">
                      <i className="fas fa-angle-down" aria-hidden="true" />
                    </span>
                  </button>
                </div>
                <div className="dropdown-menu" id="dropdown-menu" role="menu">
                  <div className="dropdown-content">
                    <a
                      href="#"
                      className="dropdown-item"
                      onClick={() => {
                        this.onFocus("left");
                      }}
                    >
                      <span className="icon">
                        <i className="fas fa-long-arrow-alt-left" />
                      </span>
                      <span>Edit Left Side</span>
                    </a>
                    <a
                      className="dropdown-item"
                      onClick={() => {
                        this.onFocus("right");
                      }}
                    >
                      <span className="icon">
                        <i className="fas fa-long-arrow-alt-right" />
                      </span>
                      <span>Edit Right Side</span>
                    </a>
                  </div>
                </div>
              </div>
            </p>
          </div>
        </div>
        {this.state.editing && (
          <div className="column">
            <Controls
              side={this.state.focus}
              index={this.props.index}
              onChange={this.onChange}
              measurement={this.state.measurement}
              {...this.state[this.state.focus]}
            />
          </div>
        )}

        <div className="column">
          <AngleViewer
            editing={this.state.editing}
            focus={this.state.focus}
            side="left"
            onClick={() => {
              this.onFocus("left");
            }}
            {...this.state.left}
          />
        </div>
        <div className="column">
          <AngleViewer
            editing={this.state.editing}
            focus={this.state.focus}
            side="right"
            onClick={() => {
              this.onFocus("right");
            }}
            {...this.state.right}
          />
        </div>
      </div>
    );
  }
}

export default Cut;



// WEBPACK FOOTER //
// ./src/Cut.js